import styles from "./reportsPage.module.css";

import { useEffect, useState } from "react";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import CheckListAPI from "../../../api/CheckListAPI";
import { downloadFile } from "../../../utils/downloadFile";

import { Text } from "../../../components/text/text";

export const SuperAdminWorkerReportsPage = () => {
    const { userId } = useParams();

    const [files, setFiles] = useState([]);

    useEffect(() => {
        CheckListAPI
            .fetchUserReportsList(userId, null)
            .then(setFiles)
            .catch(console.error);
    }, [userId]);

    const onDownload = (filename) => {
        CheckListAPI
            .fetchUserReportDownloadLink(userId, filename)
            .then((res) => downloadFile(res, filename))
            .catch(console.error);
    }

    return (
        <>
            <AdminHeader
                title="Отчеты"
                userId={userId}
            />

            {
                files && files.length > 0 ?
                    <div className={styles.files}>
                        {
                            files.map(data => (
                                <div className={styles.file} key={data.filename} onClick={() => onDownload(data.filename)}>
                                    <Text as="div" variant="body" className={styles.file_name} size={12} weight={700}>{`Отчет ${data.filename.split("_")[2] || ""}`}</Text>
                                    <Text as="div" variant="body" className={styles.file_format} size={50} weight={900}>{data.format}</Text>
                                </div>
                            ))
                        }
                    </div>
                    :
                    <div
                        style={
                            {
                                fontSize: "16px",
                                flex: "1 1 auto",
                                textAlign: "center",
                                marginTop: "10px",
                                color: "var(--app-secondary-text-color)",
                            }
                        }
                    >
                        Отчетов пока нет...
                    </div>
            }
        </>
    );
}